(() => {
'use strict';
const node=document.getElementById('bwfs-shopify-config');
if(!node)return;
let cfg,map;
try{cfg=JSON.parse(node.textContent);map=JSON.parse(cfg.variantMapText||'{}');}catch{cfg={enabled:false};map={};}
if(!map||typeof map!=='object'||Array.isArray(map)){cfg.enabled=false;map={};}
const root=(cfg.root||'/').replace(/\/?$/,'/'),buttons='[data-add],.bwc-button,[data-sticky-selection]';
let pending=false;
const message=document.createElement('p');message.setAttribute('role','status');message.setAttribute('aria-live','polite');
message.style.cssText='font:14px/1.5 Arial,sans-serif;margin:10px 0;color:#9d3c10';
document.querySelector('[data-add]')?.after(message);
const getSelection=()=>window.BW_FS_SELECTION?.();
function variant(id,items){return (items||[]).find(v=>String(v.id)===String(id));}
function build(selection,variants=cfg.variants,adapters=cfg.adapterVariants){
 if(!cfg.enabled||cfg.currency!=='EUR')throw Error('Derzeit nicht verfügbar.');
 if(!selection||!Number.isInteger(selection.count)||selection.count<1||selection.count>4||selection.sticks.length!==selection.count)throw Error('Bitte prüfe deine Auswahl.');
 if(selection.count>1&&!cfg.discountsVerified)throw Error('Diese Paketgröße ist derzeit nicht verfügbar.');
 const mapped=Object.values(map).filter(Boolean).map(String);
 if(new Set(mapped).size!==mapped.length)throw Error('Diese Auswahl ist derzeit nicht verfügbar.');
 const items=[];
 selection.sticks.forEach((stick,index)=>{
  const id=map[stick.color+'|'+stick.capacity],v=variant(id,variants);
  if(!id||!v||!v.available||Number(v.price)!==OFFER.capacities[stick.capacity])throw Error('Diese Auswahl ist derzeit nicht verfügbar.');
  items.push({id:Number(v.id),quantity:1,properties:{'_Fotostick_Einheit':String(index+1)}});
  if(stick.adapter){
   const a=variant(cfg.adapterVariantId,adapters);
   if(!a||!a.available||Number(a.price)!==OFFER.adapterCents)throw Error('Der gewählte Adapter ist derzeit nicht verfügbar.');
   items.push({id:Number(a.id),quantity:1,properties:{'_Fotostick_Einheit':String(index+1)}});
  }
 });
 return items;
}
function update(){
 let error='';
 try{build(getSelection());}catch(e){error=e.message;}
 document.querySelectorAll(buttons).forEach(b=>{b.disabled=pending||!!error;b.setAttribute('aria-disabled',String(b.disabled));});
 if(!pending)message.textContent=error;
}
async function add(){
 if(pending)return;
 const selection=getSelection();
 let items;
 try{items=build(selection);}catch(e){message.textContent=e.message;return;}
 pending=true;update();message.textContent='Wird hinzugefügt …';
 try{
  const productResponse=await fetch(cfg.productUrl+'.js',{credentials:'same-origin'});
  if(!productResponse.ok)throw Error('Die Verfügbarkeit konnte nicht geprüft werden.');
  const live=await productResponse.json();
  let adapters=cfg.adapterVariants;
  if(selection.sticks.some(s=>s.adapter)){
   const adapterResponse=await fetch(cfg.adapterProductUrl+'.js',{credentials:'same-origin'});
   if(!adapterResponse.ok)throw Error('Der Adapter konnte nicht geprüft werden.');
   adapters=(await adapterResponse.json()).variants;
  }
  items=build(selection,live.variants,adapters);
  const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items,sections:'cart-icon-bubble',sections_url:location.pathname})});
  if(!response.ok){
   const error=await response.json().catch(()=>({}));
   throw Error(typeof error.description==='string'?error.description:'Die Auswahl konnte nicht hinzugefügt werden.');
  }
  // 16.10.2026: sichtbare Properties Farbe/Speicher/Zubehör entfernt (stand doppelt zum Variantentitel im Drawer)
  // 16.10.2026: Warenkorb-Drawer (UpCart) öffnen statt zur Warenkorbseite zu springen; Header-Zähler aktualisieren. Fallback: /cart
  const result=await response.json().catch(()=>({}));
  const bubble=result.sections&&result.sections['cart-icon-bubble'],target=document.getElementById('cart-icon-bubble');
  if(bubble&&target){const html=new DOMParser().parseFromString(bubble,'text/html').querySelector('.shopify-section');if(html)target.innerHTML=html.innerHTML;}
  if(typeof window.upcartOpenCart==='function'||document.getElementById('upCart')){
   try{if(typeof window.upcartRefreshCart==='function')window.upcartRefreshCart();}catch(e){}
   try{if(typeof window.upcartOpenCart==='function')window.upcartOpenCart();}catch(e){}
   pending=false;update();message.textContent='';return;
  }
  window.location.assign(cfg.cartUrl||root+'cart');
 }catch(error){pending=false;update();message.textContent=error.message;}
}
document.addEventListener('click',event=>{
 const t=event.target.closest(buttons+', [data-cart-open]');
 if(!t)return;
 event.preventDefault();event.stopImmediatePropagation();
 if(t.hasAttribute('data-cart-open'))window.location.assign(cfg.cartUrl||root+'cart');else add();
},true);
document.addEventListener('change',()=>requestAnimationFrame(update));
document.addEventListener('click',()=>requestAnimationFrame(update));
window.BW_FS_CART={build,update};
update();
})();

